import { useNavigate } from 'react-router-dom'
// import icons from "../assets/icons";
import SJButton from '@/components/SJButton'
// import store from 'store'

const Home = () => {
  document.title = '元萝卜AI下棋机器人'
  const navigate = useNavigate()
  // TODO 默认手机号
  // const phoneNumber = store.get('phoneNumber') || '13800138000'

  return (
    <div className="page home">
      <div className="h1" style={{ textAlign: 'center', padding: '40px 0' }}>
        元萝卜AI下棋机器人
      </div>
      {/* <div onClick={() => navigate("/login")}>Login</div> */}
      <SJButton
        type="primary"
        size="large"
        // eslint-disable-next-line
        onClick={() => navigate('/player')}
      >
        棋手管理
      </SJButton>
      <div style={{ height: '30px' }}></div>
      <SJButton
        type="primary"
        size="large"
        // eslint-disable-next-line
        onClick={() => navigate('/chess')}
      >
        对弈数据
      </SJButton>
      <div style={{ height: '30px' }}></div>
      <SJButton
        type="primary"
        size="large"
        // eslint-disable-next-line
        onClick={() => navigate('/registration')}
      >
        评测考证
      </SJButton>
    </div>
  )
}
export default Home
